<template>
  <section>
    <div class="title" data-reveal-text v-if="isPC">
      全面防护，让出行更安心
    </div>
    <div class="title-content" v-if="isPC">
      全系标配包含前排中置气囊在内的 7 安全气囊<br />以及先进的 ADAS 智能驾驶辅助系统<br />用可以想到的一切提前防范，全面守护你的每一次出行
    </div>
    <div class="title-mob" data-reveal-text v-if="!isPC">
      <div class="title" data-reveal-text>
        全面防护，让出行更安心
      </div>
      <div class="title-content">
        全系标配包含前排中置气囊在内的 7 安全气囊<br />以及先进的 ADAS 智能驾驶辅助系统<br />用可以想到的一切提前防范，全面守护你的每一次出行
      </div>
    </div>
    <div style="display:flex;align-items: center;">
      <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
        <div class="swiper-container" style="overflow: visible;">
          <div class="swiper-wrapper">
            <div class="swiper-slide"
              style="overflow: hidden;box-sizing: border-box;border: 0 solid #fff;border-width: 0 30px;"
              :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgs" :key="index">
              <div v-if="!isPortrait" class="slide-flex">
                <div style="position: relative;">
                  <div v-if="item.type == 'video'">
                    <video class="custom-video" controls autoplay preload="auto" loop webkit-playsinline="true"
                      playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" muted
                      style="object-fit:cover">
                      <source :src="isPC ? item.videoPc : item.videoMob">

                    </video>
                    <div style="position: absolute;color: #fff;right: 2vw;bottom: 2vw;font-family: 'chuhei';" v-if="isPC">
                      {{ item.text }}</div>
                  </div>
                  <div v-else>
                    <div class="imgBox">
                      <img :src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                      <!-- <div style="position: absolute;color: #fff;right: 2vw;bottom: 2vw;font-family: chuhei;">{{ item.text
                      }}</div> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="des">
                <div class="main">
                  <div class="title">{{ item.title }}</div>
                </div>
              </div> -->
              </div>
              <div v-else>
                <div style="position: relative;">
                  <div v-if="item.type == 'video'">
                    <video class="custom-video" controls autoplay preload="auto" loop webkit-playsinline="true"
                      playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" muted
                      style="object-fit:cover">
                      <source :src="isPC ? item.videoPc : item.videoMob">

                    </video>
                    <!-- <div style="position: absolute;color: #fff;right: 2vw;bottom: 2vw;font-family: 'chuhei';">{{ item.text }}</div> -->
                  </div>
                  <div v-else>
                    <div class="imgBox">
                      <img :src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                    </div>
                  </div>
                </div>
                <!-- <div class="des">
                <div class="main">
                  <div class="title">{{ item.title }}</div>
                </div>
              </div> -->
              </div>
              <div :class="!isPC?'text-mob':''"
                style=" background-color: #fff;font-family: 'chuhei';text-align: center;padding-top:calc(92/750*100vw);padding-bottom:calc(285/750*100vw)"
                v-if="!isPC">{{ item.text }}</div>
              <!-- <div v-else>
            </div> -->
            </div>
          </div>
          <div v-if="!isPC" class="swiper-pagination" :class="{ 'swiper-pagination-mob': !isPC }"></div>
        </div>
        <!-- <div class="swiper-pagination"></div> -->
        <div v-if="isPC" class="sw-bottom">
          <div style="font-size: calc(20 / 1920 * 100vw);">{{ current.text }}</div>
          <div class="right-box">
            <div class="content">{{ current.index + '/' + imgs.length }}</div>
            <div class="lr-button">
              <svg id="prev" @click="prev" width="27" height="18" viewBox="0 0 27 18" fill="none"
                code-stm="event, PAGEURL, 智能驾驶_上一个"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M26 9H1M1 9L9 1M1 9L9 17" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg id="next" @click="next" width="26" height="18" viewBox="0 0 26 18" fill="none"
                code-stm="event, PAGEURL, 智能驾驶_下一个"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 9H25.5M25.5 9L17.5 1M25.5 9L17.5 17" stroke="black" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc, maidian } from "@/utils/utils.js";
export default {
  data() {
    return {
      current: {
        text: '前方防止碰撞辅助(FCA1.5)',
        index: 1,
      },
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      title: '多维守护，打造极致安适',
      text: '全系标配包含前排中置气囊在内的 7 安全气囊\n以及先进的 ADAS 智能驾驶辅助系统\n用可以想到的一切提前防范，全面守护你的每一次出行',
      imgs: [
        {
          index: 1,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0120240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0120240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "前方防止碰撞辅助(FCA1.5)",
          type: 'img'
        },
        {
          index: 2,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0320240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0320240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "前方防止碰撞辅助(FCA2)",
          type: 'img'
        },
        {
          index: 3,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0220240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0220240130.png',
          videoPc: 'https://dm30webimages.lynkco.com.cn/LynkCoPortal/media/2023/09/07/5761569626530094118.mov',
          videoMob: 'https://dm30webimages.lynkco.com.cn/LynkCoPortal/media/2023/09/07/5761569626530094118.mov',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '7安全气囊',
          text: '驾驶风格联动智能巡航控制(SCC-ML)',
          type: 'img'
        },
        {
          index: 4,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0420240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0420240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "全景显示(SVM)",
          type: 'img'
        },
        {
          index: 5,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0520240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0520240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "盲区防止碰撞辅助行驶(BCA)",
          type: 'img'
        },
        {
          index: 6,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0620240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0620240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "泊车防止碰撞辅助-前/侧/后方(PCA-F/S/R)",
          type: 'img'
        },
        {
          index: 7,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/park/3.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0720240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '',
          text: "遥控智能泊车辅助 Ⅱ (RSPA2)",
          type: 'img'
        },
        {
          index: 8,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/park/4.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0820240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '',
          text: "高速公路驾驶辅助Ⅱ(HDA2)",
          type: 'img'
        },
        {
          index: 9,
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjspc0720240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/zhineng/znjsmob0920240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'i-PEDAL单踏板模式',
          text: "安全气囊(领跑同级的前排中置气囊）",
          type: 'img'
        },
      ],
    }
  },
  mounted() {
    var that = this;
    var swiper = new Swiper('.swiper-container', {
      updateOnWindowResize: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        prevEl: "#prev", // 上一张按钮的选择器
        nextEl: "#next" // 下一张按钮的选择器
      },
      autoplay: false,
      loop: false,
      speed: 500,
    });
    swiper.init();
    swiper.on('slideChange', function () {
      that.current.text = that.imgs[this.realIndex].text
      that.current.index = that.imgs[this.realIndex].index
      maidian("智能驾驶-" + that.imgs[this.realIndex].text)
    });
  },
  methods: {
    prev() {

    },
    next() {

    }
  },
}
</script>
<style lang="scss" scoped>
.text-mob{
  color: #000;
  font-family: FZLanTingHeiS-L-GB !important;
  font-size: calc(14 / 375 * 100vw);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1px;
}
.title-outer {
  display: flex;
  padding-left: calc(6% + 2.291667vw);
  padding-bottom: 2.135417vw;
  padding-top: 2.135417vw;

  .left-line {
    width: 0.208333vw;
    height: 2.1875vw;
    background: #3A88BC;
    opacity: 1;
    // border: 4px solid #3A88BC;
    margin-right: 2.708333vw;
  }

  .main-title {
    font-family: 'chuhei';
    font-size: 2.083333vw;
    padding-bottom: 1.458333vw;
    line-height: 2.1875vw;
  }

  .sub-title {
    font-size: 1.5625vw;
  }
}

.my-weiper-container {
  width: 82.5vw;
  margin: 0 auto;

  .swiper-container {
    width: 100%;


    video {
      width: 87.5vw;
      height: 38.59vw;
      object-fit: cover;
    }

    .imgBox {
      width: 87.5vw;
      height: 38.59vw;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .slide-flex {
      display: flex;
      justify-content: space-between;
    }

    .des {
      width: calc(630/1920*100vw);
      height: 36.4583vw;
      position: relative;

      .main {
        position: absolute;
        top: calc(428/1920*100vw);
        left: calc(90/1920*100vw);
      }
    }

    .title {
      font-size: calc(36/1920*100vw);
      color: #05141F;
      line-height: calc(56/1920*100vw);
      width: calc(450/1920*100vw);
    }

    .text {
      font-size: calc(20/1920*100vw);
      color: rgba(5, 20, 31, 0.6);
      line-height: calc(32/1920*100vw);
      width: calc(450/1920*100vw);
    }
  }
}

.my-weiper-container-mob {
  width: 100vw;
  margin-top: 0;
  background: #a9b7c2;

  .swiper-container {
    width: 100%;
    background-color: #fff;

    video {
      width: 100%;
      height: 161.73vw;

    }

    .imgBox {
      width: 100vw;
      height: calc(206 / 375 * 100vw);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .slide-flex {
      display: flex;
      justify-content: space-between;
    }

    .des {
      width: calc(630/1920*100vw);
      height: 36.4583vw;
      position: relative;

      .main {
        position: absolute;
        top: calc(428/1920*100vw);
        left: calc(90/1920*100vw);
      }
    }

    .title {
      font-size: calc(36/1920*100vw);
      color: #05141F;
      line-height: calc(56/1920*100vw);
      width: calc(450/1920*100vw);
    }

    .text {
      font-size: calc(20/1920*100vw);
      color: rgba(5, 20, 31, 0.6);
      line-height: calc(32/1920*100vw);
      width: calc(450/1920*100vw);
    }
  }
}

.custom-video::-webkit-media-controls {
  display: none !important;
}

.custom-video::-webkit-media-controls-enclosure {
  display: none !important;
}

.swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
  bottom: 3vh;
}

::v-deep .swiper-pagination .swiper-pagination-bullet {
  margin-right: 0.5vw;
  width: calc(14/375*100vw);
  border-radius: 0;
  height: 1px;
}
::v-deep  .swiper-pagination .swiper-pagination-bullet-active{
  background-color: #000;
  width: calc(119/375*100vw);
}

.title {
  font-size: calc(48/1920*100vw);
  // text-align: center;
  // font-family: 'FZLanTingHeiS-R-GB-Regular';
  font-family: 'chuhei';
  padding: 140px 0 0 180px;
  // padding-bottom: calc(114/1920*100vw);
}

.title-content {
  padding: 24px 0 48px 180px;
  // font-family: 'FZLanTingHeiS-L-GB-Regular';
  font-size: calc(20 / 1920 * 100vw);
  font-weight: 400;

}

.sw-bottom {
  margin: 25px 0;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;

  .right-box {
    display: flex;

    .content {
      font-size: calc(20/1920*100vw);
      font-weight: 400;
    }

    .lr-button {
      margin-left: 48px;

      svg:first-child {
        margin-right: 18px;
      }
    }
  }
}

@media (max-width: 767px) {
  .title-mob {
    // padding: calc(150/750*100vw) 0 calc(85/750*100vw) calc(50/750*100vw);
    // display: flex;
    // align-items: center;
    font-family: 'chuhei';
    font-size: calc(48/750*100vw);
    .title{
      font-family: FZLanTingHeiS-R-GB !important;
      padding-top: calc(60 / 375 * 100vw);
      padding-left: calc(44 / 375 * 100vw);
      color: #000;
      font-size: calc(22 / 375 * 100vw);
      font-weight: 400;
      letter-spacing: 1px;
    }
    .title-content{
      font-family: FZLanTingHeiS-L-GB !important;
      // padding-top: calc(60 / 375 * 100vw);
      padding-left: calc(44 / 375 * 100vw);
      color: #000;
      font-size: calc(14 / 375 * 100vw);
      font-weight: 400;
      line-height: 1.5
    }
    .left-line {
      width: calc(5/750*100vw);
      height: calc(49/750*100vw);
      margin-right: calc(35/750*100vw);
      background: #3a88bc;
      opacity: 1;
      margin-top: calc(5/750*100vw);
    }

  }

  .swiper-pagination {
    bottom: 10vh;
  }
}</style>
